import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button,Table, Alert } from "react-bootstrap";
import Card from "../../../components/Card";
import Loader from "../../../components/partials/components/loader";
import { toast } from 'react-toastify';
import { API_TTS_PLANS_LIST, API_ACL_SETTING_LIST, API_USERS_PROFILE, API_COMPANY_LIST, API_CALL_CENTRE_LIST, API_PARENT_ACL_SETTINGS, API_SIGNUP_EMAIL_SEND_CODE, API_SIGNUP_EMAIL_VERIFY_CODE } from "../../../service/url";
import { postApiCall, getApiCall } from "../../../service/httpCall";
import { useNavigate, useParams } from "react-router-dom";
import { USER_ROLES_MAP_PROFILE, USER_STATUS } from "../../../utilities/constant";
import RenderUserCompanyFields from "../../../components/partials/dashboard/users/company";
import { Storage } from "../../../utilities/setting";
// import {getUser,
//   getUserModules,
//   getUserUpdateAccessRoleLabel,
//   ifUserAssociateCompany,
// } from "../../../utilities/setting";
import { validatePhone } from "../../../utilities/helpers";
import { ROUTES, USERS_ROLE } from "../../../utilities/constant";
import { useAuth, errorCheck } from '../auth/auth-utils';
import { USER_ROLES, USER_ROLES_MAP } from '../../../utilities/constant';

import {validateEmail} from '../../../utilities/helpers'
import "../../../assets/custom/css/custom.css";
import Select from 'react-select';
import {
  FiUser,
  FiMail,
  FiCalendar,
  FiShield,
  FiInfo,
  FiUserPlus,
  FiSend,
  FiCheckCircle,
  FiActivity,
  FiTag,
} from "react-icons/fi";
import { FaBuilding, FaHeadset } from "react-icons/fa";

function IconField({ icon: Icon, children, hasTrailing, trailing }) {
  return (
    <div
      className={`ccf-input-with-icon${hasTrailing ? " ccf-input-with-icon--trailing" : ""}${
        trailing ? " ccf-input-with-icon--icon-right" : ""
      }`}
    >
      {Icon && !trailing && (
        <span className="ccf-input-with-icon__icon">
          <Icon size={18} />
        </span>
      )}
      {children}
      {trailing && (
        <span className="ccf-input-with-icon__icon ccf-input-with-icon__icon--right">
          {trailing}
        </span>
      )}
    </div>
  );
}

const VALIDATION_MIN_PASSWORD_LENGTH = 6;

const UserAdd = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [username, setUsername] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [originalEmail, setOriginalEmail] = useState("");
  const [emailNeedsVerification, setEmailNeedsVerification] = useState(false);
  const [signupEmailOtp, setSignupEmailOtp] = useState("");
  const [signupEmailToken, setSignupEmailToken] = useState("");
  const [emailVerifiedForEdit, setEmailVerifiedForEdit] = useState(false);
  const [signupEmailBusy, setSignupEmailBusy] = useState(false);
  const [status, setStatus] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [aclSettingList, setAClSettingList] = useState([]);
  const [selectedACL, setSelectedACL] = useState("");
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [sessionReady, setSessionReady] = useState(false);
  const [profileLoading, setProfileLoading] = useState(true);
  const [selectedUserType, setSelectedUserType] = useState("");
  const [isCompanyAdmin, setCompanyAdmin] = useState(false);
  const [isCallCenterAdmin, setCallCenterAdmin] = useState(false);
  const [isSuperAdminLogged, setIsSuperAdminLogged] = useState(false);
  const [superAdminData, setSuperAdminData] = useState(null);
  const [isResellerLogged, setIsResellerLogged] = useState(false);
  const [isCompanyUserLogged, setIsCompanyUserLogged] = useState(false);
  const [isCallCenterAdminLogged, setIsCallCenterAdminLogged] = useState(false);
  const [isReseller, setIsReseller] = useState(false);
  const [channel, setChannel] = useState(0);
  const [callCenterAdminAgent , setCallCenterAdminAgent] = useState(0);
  const [callCenterAdminTeamlead , setCallCenterAdminTeamlead] = useState(0);
  const [agent , setAgent] = useState(0);
  const [liveAgent , setLiveAgent] = useState(0);
  const [subLicenceId, setSubLicenceId] = useState("");
  const [selectedFlowType, setSelectedFlowType] = useState("");
  const [companyUserRole, setCompanyUserRole] = useState(false);
  const [currentEditUserRole, setCurrentEditUserRole] = useState(null);
  const [availableLicence, setAvailableLicence] = useState({});
  const [expiryDate, setExpiryDate] = useState(null);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [editUserParent, setEditUserParent] = useState(null);
  const [errors, setErrors] = useState({
      role_ccagent: "",
      role_ccteamlead: "",
      agent: "",
      channel: "",
      live_agent: ""
    });

  const [currentUserLicence, setCurrentUserLicence] = useState({
      role_ccagent: "",
      role_ccteamlead: "",
      agent: "",
      channel: "",
      live_agent: ""
  });

  const [currentUserTotalLicence, setCurrentUserTotalLicence] = useState({
      role_ccagent: "",
      role_ccteamlead: "",
      agent: "",
      channel: "",
      live_agent: ""
  });

  const usedLicence = {
    role_ccagent: "",
    role_ccteamlead: "",
    agent: "",
    channel: "",
    live_agent: ""
  };

  const [emailError, setEmailError] = useState("");
  const [nameError, setNameError] = useState("");
  const [companyList, setCompanyList] = useState([])
  const [selectedCompany, setSelectedCompany] = useState("")
  const [callCenterList, setCallCenterList] = useState([])
  const [selectedCallCenter, setSelectedCallCenter] = useState("")
  const [tts_plan_id, setTtsPlanId] = useState(null);
  const [showTtsPlanId, setShowTtsPlanId] = useState(false);
  const [ttsPlanList, setTtsPlanList] = useState([]);
  const [accountType, setAccountType] = useState("0");
  const [parentAccountType, setParentAccountType] = useState(null);

  useEffect(() => {
    async function superadminCheck() {
      const rawUser = Storage.getItem('user');
      if (!rawUser) {
        console.error("User not found in Storage");
        return null; // or handle as needed
      }

      let user;
      try {
        user = JSON.parse(rawUser);
        setLoggedInUser(user);
      } catch (e) {
        console.error("Invalid JSON in user from Storage", e);
        return null;
      }
      if (user.role !== USER_ROLES.RESELLER && user.role !== USER_ROLES.SUPERADMIN) {
        // const updatedAvailableLicence = {
        //   role_ccagent: (user?.sub_user_licence?.available_licence?.role_ccagent || 0) + (callCenterAdminAgent || 0),
        //   role_ccteamlead: (user?.sub_user_licence?.available_licence?.role_ccteamlead || 0) + (callCenterAdminTeamlead || 0),
        //   agent: (user?.sub_user_licence?.available_licence?.agent || 0) + (agent || 0),
        //   channel: (user?.sub_user_licence?.available_licence?.channel || 0) + (channel || 0),
        //   live_agent: (user?.sub_user_licence?.available_licence?.live_agent || 0) + (liveAgent || 0),
        // };
        // setAvailableLicence(updatedAvailableLicence);
      }

      if (user.role === USER_ROLES.SUPERADMIN) {
        setIsSuperAdminLogged(true)
        setSuperAdminData(user);
      }
      if (user.role === USER_ROLES.RESELLER) {
        setIsResellerLogged(true)
      }
      if (user.role === USER_ROLES.COMPANY_ADMIN) {
        setIsCompanyUserLogged(true)
      }
      if (user.role === USER_ROLES.CALL_CENTRE_ADMIN) {
        setCallCenterList([{
          id: user?.callcenter?.id,
          name: user?.callcenter?.name
        }])

        setSelectedCallCenter(user?.callcenter?.id)
        setIsCallCenterAdminLogged(true)
      }
      if (selectedUserType === USER_ROLES.SUPERADMIN) {
        setIsSuperAdmin(true);
      }
      if (selectedUserType === USER_ROLES.COMPANY_ADMIN) {
        setCompanyAdmin(true);
      }
      if (selectedUserType === USER_ROLES.CALL_CENTRE_ADMIN) {
        setCallCenterAdmin(true);
      }
      if (user.role === USER_ROLES.COMPANY_ADMIN){
        setCompanyUserRole(true);
      }

      if (user.role === USER_ROLES.RESELLER) {
        setIsReseller(true);
      }

      if (user.role === USER_ROLES.COMPANY_ADMIN) {
        // setCompanyList([{
        //   id: user?.company?.id,
        //   name: user?.company?.name
        // }])
        // setSelectedCompany(user?.company?.id)
        setCompanyAdmin(true);
      }
      
      setSessionReady(true);
    }
    superadminCheck();
  }, [selectedUserType]);

  useEffect(() => {
      if (selectedACL) {
        const selectedAclDetails = aclSettingList?.filter((item) => {
          return item?.id == selectedACL
        });
        if (selectedAclDetails && selectedAclDetails?.length > 0) {
          const modules = getKeysWithTrueValues(JSON.parse(selectedAclDetails?.[0]?.module_operations||'{}'));
          if (modules?.includes("TTS")) {
            setShowTtsPlanId(true);
          } else {
            setShowTtsPlanId(false);
          }
        }
      } else {
        setShowTtsPlanId(false);
      }
    }, [selectedACL]);

  function getKeysWithTrueValues(moduleOperations) {
    return Object.keys(moduleOperations).filter(key => {
        const permissions = moduleOperations[key];
        return Object.values(permissions).some(value => value === true);
    });
  }

  useEffect(() => {
    getApiCall(API_TTS_PLANS_LIST).then((resp) => {
      // if (isSuperAdmin && superAdminData) {
      //   const filteredPlans = resp?.filter((item) => {
      //     return item.user_id == superAdminData?.id
      //   });
      //   setTtsPlanList(filteredPlans);
      // } else {
        setTtsPlanList(resp) 
      // }
    }).catch((error) => { toast.error(JSON.stringify(error)) })
  }, [isSuperAdmin, superAdminData]);

  function getProfileApiUrl() {
    return API_USERS_PROFILE.replace(":id", id);
  }

  // Fetch ACLs that are either the parent's own ACL or created by the parent
  useEffect(() => {
    if (!sessionReady || profileLoading || !id) {
      return;
    }
    const url = `${API_PARENT_ACL_SETTINGS}/${id}`;
    getApiCall(url, {})
      .then(onAClSettingListSuccess)
      .catch(onError);
  }, [sessionReady, profileLoading, id]);

  useEffect(() => {
    if (!id) {
      return;
    }
    setProfileLoading(true);
    const profileApiUrl = getProfileApiUrl();
    getApiCall(profileApiUrl, {})
      .then(onProfileGetSuccess)
      .catch((err) => {
        setProfileLoading(false);
        onError(err);
      });
  }, [id]);


  useEffect(() => {
    checkAuth(setToastProps, setShowToast)
  }, []);

  useEffect(() => {
    if (!selectedUserType) {
      setSelectedACL("");
    }
  }, [selectedUserType]);

  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);

  useEffect(() => {
      if (!sessionReady || profileLoading) {
        return;
      }
      let companiesUrl = null;
      if (isSuperAdminLogged && superAdminData) {
        companiesUrl = `${API_COMPANY_LIST}?queryData=all`;
      } else {
        companiesUrl = API_COMPANY_LIST;
      }
      getApiCall(companiesUrl, {})
        .then(onCompanyListSuccess)
        .catch(onError);
    }, [sessionReady, profileLoading, isSuperAdminLogged, superAdminData, editUserParent]);
  
    function onCompanyListSuccess(resp) {
     setCompanyList(resp)
    //  if (isSuperAdminLogged && superAdminData && (editUserParent?.id == superAdminData?.id)) {
    //   const filteredCompanies = resp.filter((item) => {
    //     return item.created_by == superAdminData?.id
    //   });
    //   setCompanyList(filteredCompanies);
    //   }
    }

     useEffect(() => {
        if (!sessionReady || profileLoading) {
          return;
        }
        getApiCall(API_CALL_CENTRE_LIST, {})
          .then(onCallcenterListSuccess)
          .catch(onError);
      }, [sessionReady, profileLoading]);
    
  function onCallcenterListSuccess(resp) {
    const isSelectedCallCenterAdmin = selectedUserType === USERS_ROLE.CALL_CENTRE_ADMIN;

    if ((!isCallCenterAdmin ) ||
        (isCompanyAdmin && !isSelectedCallCenterAdmin)) {
      setCallCenterList(resp);
    }
  }

  function onProfileGetSuccess(resp) {

    const formattedDate = resp.expiry_date
      ? new Date(resp.expiry_date).toISOString().split("T")[0]
      : "";
    setTtsPlanId(resp.tts_plan_id);
    setEditUserParent(resp.createdByUser);
    setExpiryDate(formattedDate);
    setSubLicenceId(resp.sub_user_licence_id?.id);
    setCurrentEditUserRole(resp?.role);
    setUsername(resp.username);
    setStatus(resp.status);
    setName(resp.name);
    setEmail(resp.email);
    setOriginalEmail(resp.email || "");
    setEmailNeedsVerification(resp.email_verified === false);
    setSignupEmailToken("");
    setSignupEmailOtp("");
    setEmailVerifiedForEdit(false);
    setSelectedACL(resp.acl_settings_id);
    setSelectedUserType(resp.role)
    setSelectedFlowType(resp?.flow_type || null);
    setCallCenterAdminAgent(resp?.sub_user_licence?.available_licence?.role_ccagent);
    setCallCenterAdminTeamlead(resp?.sub_user_licence?.available_licence?.role_ccteamlead);
    setAgent(resp?.sub_user_licence?.available_licence?.agent);
    setChannel(resp?.sub_user_licence?.available_licence?.channel );
    setLiveAgent(resp?.sub_user_licence?.available_licence?.live_agent);
    setCurrentUserLicence({
      role_ccagent: resp?.sub_user_licence?.available_licence?.role_ccagent,
      role_ccteamlead: resp?.sub_user_licence?.available_licence?.role_ccteamlead,
      agent: resp?.sub_user_licence?.available_licence?.agent,
      channel: resp?.sub_user_licence?.available_licence?.channel,
      live_agent: resp?.sub_user_licence?.available_licence?.live_agent
    })
    setCurrentUserTotalLicence({
      role_ccagent: resp?.sub_user_licence?.total_licence?.role_ccagent,
      role_ccteamlead: resp?.sub_user_licence?.total_licence?.role_ccteamlead,
      agent: resp?.sub_user_licence?.total_licence?.agent,
      channel: resp?.sub_user_licence?.total_licence?.channel,
      live_agent: resp?.sub_user_licence?.total_licence?.live_agent
    })

      if (resp.account_type !== undefined && resp.account_type !== null) {
    setAccountType(String(resp.account_type));
  } else {
    setAccountType("0");
  }
  
  if (resp.createdByUser?.account_type !== undefined && resp.createdByUser?.account_type !== null) {
    setParentAccountType(Number(resp.createdByUser.account_type));
  } else {
    try {
      const rawEditor = Storage.getItem("user");
      if (rawEditor) {
        const editor = JSON.parse(rawEditor);
        if (editor?.account_type !== undefined && editor?.account_type !== null) {
          setParentAccountType(Number(editor.account_type));
        }
      }
    } catch (_) {
      /* ignore */
    }
  }

    if (resp.callcenter) {
      setSelectedCallCenter(resp?.callcenter?.id)
    }

    //Set company details
    const companyDetails = resp.company;


    if (companyDetails) {
      setSelectedCompany(companyDetails.id)
    }
    if (resp.assigned_company) {
      setSelectedCompany(resp.assigned_company);
    }

    setProfileLoading(false);
  }

  function onAClSettingListSuccess(resp) {
     setAClSettingList(resp);
  }

  function validateForm() {
    let valid = true;

    if (!username.trim()) {
      valid = false;
      toast.error("Username required");
    } else if (!validateName(name)) {
      valid = false;
      if (!name.trim()) {
        toast.error("Name required");
      } else {
        toast.error(nameError || "Invalid name format");
      }
    } else if (!status || isNaN(status)) {
      valid = false;
      toast.error("Status required");
    } else if (selectedUserType === USER_ROLES.COMPANY_ADMIN || selectedUserType === USER_ROLES.RESELLER) {
      if (selectedCompany === "" || selectedCompany === null || !selectedCompany) {
        valid = false;
        toast.error("Company is required");
      }
    }

    if (
      selectedUserType &&
      !selectedACL &&
      selectedUserType !== USER_ROLES.CALL_CENTRE_AGENT
    ) {
      valid = false;
      toast.error("ACL Settings is required");
    }

    if (isSuperAdmin || isCompanyAdmin || isCallCenterAdmin) {
      if (!selectedUserType.trim()) {
        valid = false;
        toast.error("UserType required");
      }
    }

    if (selectedUserType === USER_ROLES.CALL_CENTRE_ADMIN) {
          if (!selectedCallCenter.trim()) {
            valid = false;
            toast.error("Callcenter required");
          }
        }
    if ((loggedInUser?.id == editUserParent?.id) && !expiryDate) {
      valid = false;
      toast.error("Expiry Date required");
    } else if ((loggedInUser?.id == editUserParent?.id) && expiryDate) {
      // Validate expiry date format and range
      const selectedDate = new Date(expiryDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);
      
      // Check if date is valid
      if (isNaN(selectedDate.getTime())) {
        valid = false;
        toast.error("Invalid expiry date format. Please select a valid date.");
      } else {
        // Check if date is in the past
        if (selectedDate < today) {
          valid = false;
          toast.error("Expiry Date cannot be in the past. Please select a future date.");
        } else {
          // Check if date is too far in the future (max 100 years from today)
          const maxDate = new Date();
          maxDate.setFullYear(maxDate.getFullYear() + 100);
          maxDate.setHours(0, 0, 0, 0);
          
          if (selectedDate > maxDate) {
            valid = false;
            toast.error("Expiry Date cannot be more than 100 years in the future. Please select a reasonable date.");
          }
        }
      }
    }
    if (showTtsPlanId) {
      if (!tts_plan_id) {
        valid = false;
        toast.error("TTS Plan is required when selecting ACL having TTS");
      }
    }

    const emailValidationError = validateEmail(email);
    if (emailValidationError) {
      setEmailError(emailValidationError);
      valid = false;
      toast.error("Enter a valid email");
    }

    if (emailRequiresVerification() && (!emailVerifiedForEdit || !signupEmailToken)) {
      valid = false;
      toast.error("Verify this email first: use Send code, then enter the OTP and click Verify OTP.");
    }

    if (accountType === "" || accountType === null || accountType === undefined) {
      valid = false;
      toast.error("Account Type is required");
    } else if (![0, 1].includes(Number(accountType))) {
      valid = false;
      toast.error("Account Type must be Promotional or Transactional");
    }

    return valid;
  }

  const normalizeEmail = (value) => String(value || "").trim().toLowerCase();

  const emailRequiresVerification = () =>
    normalizeEmail(email) !== normalizeEmail(originalEmail) || emailNeedsVerification;


  const updateLocalStorage = async (finalData) => {

    try {
        // Save updated user data back to Storage
        Storage.setItem('user', JSON.stringify(finalData));
    } catch (error) {
      console.error('Error updating available licences:', error);
    }
  };

  async function submitForm() {
    setButtonDisable(true);

    if (!validateForm()) {
      setButtonDisable(false);
      return;
    }

    if (Object.values(errors).some(value => value !== "")) {
      toast.error("Enter All correct values");
      setButtonDisable(false);
      return;
    }
    const sub_licence = {
      role_ccagent: Number(callCenterAdminAgent) || 0,
      role_ccteamlead: Number(callCenterAdminTeamlead) || 0,
      agent: Number(agent) || 0,
      channel: Number(channel) || 0,
      live_agent: Number(liveAgent) || 0
    };


    const params = { username, name, email, status,
      acl_settings: (selectedACL === "") ? null: selectedACL,
       account_type: Number(accountType), 
    };

    if (emailRequiresVerification() && signupEmailToken) {
      params.signup_email_token = signupEmailToken;
    }

    if (showTtsPlanId) {
      params.tts_plan_id = tts_plan_id;
    }

    if (!isCallCenterAdmin) {
      params.company = selectedCompany !== "" ? selectedCompany : null;
    }

    params.role = selectedUserType

    if (selectedUserType === USER_ROLES.CALL_CENTRE_ADMIN) {
          params.callcenterId = selectedCallCenter
        }

    if (selectedUserType === USER_ROLES.CALL_CENTRE_ADMIN) {
      params.flow_type = Number(selectedFlowType)
    }

    let finalData


    // if (!isResellerLogged && !isSuperAdminLogged) {
    //   const { user, newAvailableLicences } = await updateAvailableLicences(sub_licence);
    //   finalData = user;
    //   params.parent_licence = newAvailableLicences;
    // }
    
    // if (!isSuperAdminLogged) {
    //   params.sub_licence = sub_licence
    // }
    if (loggedInUser?.id == editUserParent?.id) {
      params.expiry_date = expiryDate;
    }
    try {
      const profileApiUrl = getProfileApiUrl();
      const resp = await postApiCall(profileApiUrl, params);
    
      if (resp) {
        await onUserUpdateSuccess(resp, finalData);
      } else {
        throw new Error(resp?.message || "User Updation failed");
      }
    } catch (error) {
      onError(error);
    }
  }

   async function onUserUpdateSuccess(resp, finalData) {
      if (!isResellerLogged && !isSuperAdminLogged) {
        // await updateLocalStorage(finalData);
      }
      toast.success("User updated successfully");
      setTimeout(() => {
        navigate(`/${ROUTES.USERS.LIST}`);
      }, 1500);
    }

    function onError(err) {
      setButtonDisable(false);
    
      let message = "An unknown error occurred.";
    
      if (err?.response?.data?.message) {
        message = err.response.data.message;
      } else if (err?.message) {
        message = err.message;
      } else if (typeof err === 'string') {
        message = err;
      }
    
      if (message.includes('TokenExpiredError')) {
        errorCheck(err, navigate, setToastProps, setShowToast);
        return;
      }
    
      toast.error(message);
    }
    

  function RenderUserStatusOptions() {
    let arrStatusOptions = [<option key="select-status" value="">Select status</option>];

    USER_STATUS.map((val,idx) => {
      arrStatusOptions.push(<option key={idx} value={val.value}>{val.label}</option>);
    });

    return arrStatusOptions;
  }
 
 const handleEmailChange = (e) => {
  const value = e.target.value;
  setEmail(value);
  setEmailError(validateEmail(value));
  setSignupEmailToken("");
  setSignupEmailOtp("");
  setEmailVerifiedForEdit(false);
};

  const sendSignupEmailCode = async () => {
    if (!email.trim() || validateEmail(email)) {
      toast.error("Enter a valid email before sending a code.");
      return;
    }
    setSignupEmailBusy(true);
    try {
      await postApiCall(API_SIGNUP_EMAIL_SEND_CODE, {
        email: email.trim(),
        exclude_user_id: id,
      });
      setSignupEmailToken("");
      setEmailVerifiedForEdit(false);
      toast.success("Verification code sent. Check the inbox for this email.");
    } catch (err) {
      toast.error(typeof err === "string" ? err : "Could not send verification code");
    } finally {
      setSignupEmailBusy(false);
    }
  };

  const verifySignupEmailOtp = async () => {
    if (!email.trim() || validateEmail(email)) {
      toast.error("Enter a valid email.");
      return;
    }
    if (!signupEmailOtp || signupEmailOtp.length !== 6) {
      toast.error("Enter the 6-digit code from the email.");
      return;
    }
    setSignupEmailBusy(true);
    try {
      const data = await postApiCall(API_SIGNUP_EMAIL_VERIFY_CODE, {
        email: email.trim(),
        otp: signupEmailOtp.trim(),
      });
      if (data?.signupEmailToken) {
        setSignupEmailToken(data.signupEmailToken);
        setEmailVerifiedForEdit(true);
        toast.success("Email verified. You can save the user now.");
      } else {
        toast.error("Unexpected response from server");
      }
    } catch (err) {
      toast.error(typeof err === "string" ? err : "Verification failed");
      setEmailVerifiedForEdit(false);
      setSignupEmailToken("");
    } finally {
      setSignupEmailBusy(false);
    }
  };

 const validateName = (value) => {
   const trimmedValue = value.trim();
   if (!trimmedValue) {
     setNameError("Name is required");
     return false;
   }
   if (trimmedValue.length < 2 || trimmedValue.length > 100) {
     setNameError("Name must be between 2 and 100 characters");
     return false;
   }
    if (!/^[a-zA-Z0-9_ ]+$/.test(trimmedValue)) {
     setNameError("Name can only contain letters, numbers, underscores, and spaces");
     return false;
   }
   setNameError("");
   return true;
 };

  const showCompanyAssign =
    selectedUserType === USER_ROLES.RESELLER ||
    selectedUserType === USER_ROLES.COMPANY_ADMIN;

  const canEditExpiry = loggedInUser?.id == editUserParent?.id;

  const todayStr = new Date().toISOString().split("T")[0];
  const editExpiryMaxDateStr = (() => {
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() + 100);
    const globalMax = maxDate.toISOString().split("T")[0];
    if (editUserParent?.expiry_date) {
      const parentDateStr = new Date(editUserParent.expiry_date).toISOString().split("T")[0];
      return parentDateStr < globalMax ? parentDateStr : globalMax;
    }
    return globalMax;
  })();

  const roleDisplayLabel =
    USER_ROLES_MAP_PROFILE[selectedUserType] || selectedUserType || "—";

  const isPageLoading = !sessionReady || profileLoading;

  return (
    <>
      <div>
        <Row>
          <Col xl="12" lg="12">
            <Card>
              <Card.Header className="d-none" />
              <Card.Body className="user-create-form-card">
                <div className="new-user-info company-create-form user-create-form user-edit-form">
                  <div className="user-create-form__hero">
                    <div className="user-create-form__hero-left">
                      <span className="user-create-form__hero-icon" aria-hidden="true">
                        <FiUser size={22} />
                      </span>
                      <div>
                        <h5 className="user-create-form__hero-title">Edit User Information</h5>
                        <p className="user-create-form__hero-subtitle">
                          Update user details and access within the system.
                        </p>
                      </div>
                    </div>
                    <div className="user-create-form__required-note">
                      <FiInfo size={14} aria-hidden="true" />
                      <span>
                        All fields marked with <span className="text-danger">*</span> are required
                      </span>
                    </div>
                  </div>

                  {isPageLoading ? (
                    <div className="user-edit-form__loading" aria-busy="true" aria-live="polite">
                      <Loader />
                      <p className="user-edit-form__loading-text">Loading user details…</p>
                    </div>
                  ) : (
                  <form autoComplete="off">
                    {emailNeedsVerification && (
                      <Alert variant="warning" className="user-edit-form__alert">
                        This user has not verified their email yet. Send a verification code to the
                        email below and click Verify OTP before saving.
                      </Alert>
                    )}

                    <div className="row user-create-form__row">
                      <Form.Group className="col-12 col-lg-4 form-group mb-0">
                        <Form.Label>
                          Username <span className="text-danger">*</span>
                        </Form.Label>
                        <IconField icon={FiUser}>
                          <Form.Control
                            type="text"
                            id="username"
                            className="ccf-input-with-icon__control user-edit-form__readonly"
                            placeholder="Username"
                            readOnly
                            value={username}
                          />
                        </IconField>
                      </Form.Group>

                      <Form.Group className="col-12 col-lg-4 form-group mb-0">
                        <Form.Label>
                          Full Name <span className="text-danger">*</span>
                        </Form.Label>
                        <IconField icon={FiUser}>
                          <Form.Control
                            type="text"
                            id="name"
                            className={`ccf-input-with-icon__control${nameError ? " is-invalid" : ""}`}
                            placeholder="Enter full name"
                            maxLength={100}
                            value={name}
                            onChange={(e) => {
                              setName(e.target.value);
                              validateName(e.target.value);
                            }}
                            onBlur={(e) => validateName(e.target.value)}
                            required
                          />
                        </IconField>
                        {nameError && <div className="invalid-feedback d-block">{nameError}</div>}
                      </Form.Group>

                      <Form.Group className="col-12 col-lg-4 form-group mb-0">
                        <Form.Label>Role</Form.Label>
                        <IconField icon={FiUserPlus}>
                          <Form.Control
                            id="userTypeDisplay"
                            type="text"
                            readOnly
                            className="ccf-input-with-icon__control user-edit-form__readonly"
                            value={roleDisplayLabel}
                            placeholder="—"
                          />
                        </IconField>
                      </Form.Group>
                    </div>

                    <div className="row user-create-form__row">
                      <Form.Group className="col-12 col-lg-8 form-group mb-0 user-create-form__email-col">
                        <Form.Label>
                          Email <span className="text-danger">*</span>
                        </Form.Label>
                        <IconField icon={FiMail}>
                          <Form.Control
                            type="email"
                            id="email"
                            className={`ccf-input-with-icon__control${
                              emailError ? " is-invalid" : ""
                            }${emailVerifiedForEdit ? " is-verified-email" : ""}`}
                            placeholder="Enter email address"
                            maxLength={100}
                            value={email}
                            onChange={handleEmailChange}
                            required
                          />
                        </IconField>
                        {emailError && (
                          <div className="invalid-feedback d-block">{emailError}</div>
                        )}
                        {emailRequiresVerification() && (
                          <div className="default-user-email-verify user-create-form__email-verify">
                            <IconField icon={FiShield}>
                              <Form.Control
                                type="text"
                                inputMode="numeric"
                                className="ccf-input-with-icon__control default-user-email-verify__otp"
                                placeholder="6-digit code"
                                maxLength={6}
                                value={signupEmailOtp}
                                onChange={(e) =>
                                  setSignupEmailOtp(e.target.value.replace(/\D/g, "").slice(0, 6))
                                }
                                disabled={signupEmailBusy}
                              />
                            </IconField>
                            <Button
                              type="button"
                              variant="outline-primary"
                              size="sm"
                              className="default-user-email-verify__btn default-user-email-verify__btn--send"
                              disabled={
                                signupEmailBusy || !email.trim() || !!validateEmail(email)
                              }
                              onClick={sendSignupEmailCode}
                            >
                              <FiSend size={14} className="me-1" />
                              Send Code
                            </Button>
                            <Button
                              type="button"
                              variant="outline-success"
                              size="sm"
                              className="default-user-email-verify__btn default-user-email-verify__btn--verify"
                              disabled={signupEmailBusy || signupEmailOtp.length !== 6}
                              onClick={verifySignupEmailOtp}
                            >
                              <FiCheckCircle size={14} className="me-1" />
                              Verify OTP
                            </Button>
                            {emailVerifiedForEdit && (
                              <span className="text-success small default-user-email-verify__ok">
                                Email verified
                              </span>
                            )}
                          </div>
                        )}
                      </Form.Group>

                      <Form.Group className="col-12 col-lg-4 form-group mb-0">
                        <Form.Label>
                          Status <span className="text-danger">*</span>
                        </Form.Label>
                        <IconField icon={FiActivity}>
                          <Form.Select
                            id="status"
                            value={status}
                            className="ccf-input-with-icon__control ccf-input-with-icon__select"
                            onChange={(e) => setStatus(e.target.value)}
                          >
                            <RenderUserStatusOptions />
                          </Form.Select>
                        </IconField>
                      </Form.Group>
                    </div>

                    <div className="row user-create-form__row">
                      {canEditExpiry && (
                        <Form.Group className="col-12 col-md-6 col-lg-4 form-group mb-0">
                          <Form.Label>
                            Access Valid Till (User Expiry Date){" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <IconField trailing={<FiCalendar size={18} />}>
                            <Form.Control
                              type="date"
                              className="ccf-input-with-icon__control ccf-input-with-icon__control--date"
                              min={todayStr}
                              max={editExpiryMaxDateStr}
                              value={expiryDate || ""}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value && value > editExpiryMaxDateStr) {
                                  toast.error(
                                    "Expiry Date cannot be greater than parent user's expiry date."
                                  );
                                  setExpiryDate(editExpiryMaxDateStr);
                                } else {
                                  setExpiryDate(value);
                                }
                              }}
                            />
                          </IconField>
                        </Form.Group>
                      )}

                      <Form.Group className="col-12 col-md-6 col-lg-4 form-group mb-0">
                        <Form.Label>
                          Account Type <span className="text-danger">*</span>
                        </Form.Label>
                        <IconField icon={FiTag}>
                          <Form.Select
                            id="accountType"
                            value={accountType}
                            className={`ccf-input-with-icon__control ccf-input-with-icon__select${
                              accountType === "" ? " is-invalid" : ""
                            }`}
                            onChange={(e) => setAccountType(e.target.value)}
                          >
                            <option value="">Select Account Type</option>
                            {parentAccountType === null || parentAccountType === undefined ? (
                              <>
                                <option value="0">Promotional</option>
                                <option value="1">Transactional</option>
                              </>
                            ) : Number(parentAccountType) === 0 ? (
                              <option value="0">Promotional</option>
                            ) : (
                              <option value="1">Transactional</option>
                            )}
                          </Form.Select>
                        </IconField>
                        <p className="user-create-form__field-hint">
                          {parentAccountType === null || parentAccountType === undefined
                            ? "Promotional or transactional account."
                            : Number(parentAccountType) === 0
                              ? "Inherited from parent: promotional only."
                              : "Inherited from parent: transactional only."}
                        </p>
                      </Form.Group>
                    </div>

                    <div className="row user-create-form__row">
                      <Form.Group className="col-12 col-md-6 form-group mb-0 user-create-form__acl-col">
                        <Form.Label>
                          ACL Settings
                          {selectedUserType &&
                            selectedUserType !== USER_ROLES.CALL_CENTRE_AGENT && (
                              <span className="text-danger"> *</span>
                            )}
                        </Form.Label>
                        <IconField icon={FiShield}>
                          <Form.Select
                            id="aclSetting"
                            required={
                              !!selectedUserType &&
                              selectedUserType !== USER_ROLES.CALL_CENTRE_AGENT
                            }
                            disabled={!selectedUserType}
                            value={selectedACL}
                            className="ccf-input-with-icon__control ccf-input-with-icon__select"
                            onChange={(e) => setSelectedACL(e.target.value)}
                          >
                            <option value="">Select ACL</option>
                            {aclSettingList.map((val, idx) => (
                              <option key={idx} value={val.id}>
                                {val.acl_name}
                              </option>
                            ))}
                          </Form.Select>
                        </IconField>
                        <p className="user-create-form__field-hint">
                          Select the access control level for this user.
                        </p>
                      </Form.Group>

                      {showCompanyAssign && (
                        <Form.Group className="col-12 col-md-6 form-group mb-0 user-create-form__company-col">
                          <Form.Label>
                            Assign Company <span className="text-danger">*</span>
                          </Form.Label>
                          <IconField icon={FaBuilding}>
                            <Form.Select
                              id="assignCompany"
                              required
                              value={selectedCompany}
                              disabled
                              className="ccf-input-with-icon__control ccf-input-with-icon__select user-edit-form__readonly"
                              onChange={(e) => setSelectedCompany(e.target.value)}
                            >
                              <option value="">Select company</option>
                              {companyList.map((val, idx) => (
                                <option key={idx} value={val.id}>
                                  {val.name}
                                </option>
                              ))}
                            </Form.Select>
                          </IconField>
                        </Form.Group>
                      )}
                    </div>

                    {(isSuperAdminLogged || isCompanyUserLogged || isCallCenterAdminLogged) && (
                      <div className="row user-create-form__row">
                        {currentEditUserRole === USER_ROLES.CALL_CENTRE_ADMIN && (
                          <Form.Group className="col-12 col-md-6 form-group mb-0">
                            <Form.Label>
                              Flow Type <span className="text-danger">*</span>
                            </Form.Label>
                            <IconField icon={FaHeadset}>
                              <Form.Select
                                id="callCenterType"
                                required
                                value={selectedFlowType ?? ""}
                                className="ccf-input-with-icon__control ccf-input-with-icon__select"
                                onChange={(e) => setSelectedFlowType(e.target.value)}
                              >
                                <option value="" disabled hidden>
                                  Select Flow Type
                                </option>
                                <option value="0">Asterisk</option>
                              </Form.Select>
                            </IconField>
                          </Form.Group>
                        )}

                        {selectedUserType === USER_ROLES.CALL_CENTRE_ADMIN && (
                          <Form.Group className="col-12 col-md-6 form-group mb-0">
                            <Form.Label>
                              Call Center <span className="text-danger">*</span>
                            </Form.Label>
                            <IconField icon={FaHeadset}>
                              <Form.Select
                                id="callCenterSelect"
                                required
                                value={selectedCallCenter}
                                disabled
                                className="ccf-input-with-icon__control ccf-input-with-icon__select user-edit-form__readonly"
                                onChange={(e) => setSelectedCallCenter(e.target.value)}
                              >
                                <option value="">Select call center</option>
                                {callCenterList.map((val, idx) => (
                                  <option key={idx} value={val.id}>
                                    {val.name}
                                  </option>
                                ))}
                              </Form.Select>
                            </IconField>
                          </Form.Group>
                        )}

                      </div>
                    )}

                    {showTtsPlanId && (
                      <div className="row user-create-form__row">
                        <Form.Group className="col-12 col-md-6 form-group mb-0">
                          <Form.Label>
                            TTS Plan <span className="text-danger">*</span>
                          </Form.Label>
                          <IconField icon={FiShield}>
                            <Form.Select
                              id="tts_plan_id"
                              required
                              value={tts_plan_id || ""}
                              className="ccf-input-with-icon__control ccf-input-with-icon__select"
                              onChange={(e) => setTtsPlanId(e.target.value)}
                            >
                              <option value="">Select TTS Plan</option>
                              {ttsPlanList.map((val, idx) => (
                                <option key={idx} value={val.id}>
                                  {val.plan_name}
                                </option>
                              ))}
                            </Form.Select>
                          </IconField>
                        </Form.Group>
                      </div>
                    )}

                    {/* {!isSuperAdminLogged && !(isResellerLogged && selectedUserType && selectedUserType === USER_ROLES.RESELLER) && 
                     <div className="scroll-container">

                       <Table
                        striped
                        bordered
                        hover
                        responsive
                        style={{ textAlign: "center" }}
                       >
                        <thead>
                          <tr>
                            <th style={{ width: "15%" }}>
                              Callcenter Admin Teamlead
                            </th>
                            <th style={{ width: "25%" }}>Total Agent</th>
                            <th style={{ width: "25%" }}>Live Agent</th>
                            <th style={{ width: "25%" }}>Channel</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                             <td>                            
                              <Form.Group className="form-group">
                                  <Form.Control
                                  type="number"
                                  id="callcenterAdminTeamLead"
                                  placeholder="Callcenter Admin Teamlead"
                                  maxLength={100}
                                  min={0}
                                  max={availableLicence.role_ccteamlead}
                                  value={callCenterAdminTeamlead}
                                  onChange={(e) => setCallCenterAdminTeamlead(validateInput(e.target.value, "role_ccteamlead"))}
                                  required
                                  />
                                  {errors.role_ccteamlead && <small className="text-danger">{errors.role_ccteamlead}</small>}
                                </Form.Group>
                              </td>
                              <td style={{ minHeight: "60px" , minWidth:"160px" }}>                        
                                <Form.Group className="form-group">
                                  <Form.Control
                                  type="number"
                                  id="agent"
                                  placeholder="Agent"
                                  maxLength={100}
                                  min={0}
                                  max={availableLicence.agent}
                                  value={agent}
                                  onChange={(e) => setAgent(validateInput(e.target.value, "agent"))}
                                  required
                                  />
                                  {errors.agent && <small className="text-danger">{errors.agent}</small>}
                                </Form.Group>
                               </td>
                                <td style={{ minHeight: "60px" , minWidth:"160px" }}>                        
                                  <Form.Group className="form-group">
                                  <Form.Control
                                  type="number"
                                  id="agentLive"
                                  placeholder="Live Agent"
                                  maxLength={100}
                                  min={0}
                                  max={availableLicence?.live_agent}
                                  value={liveAgent}
                                  onChange={(e) => setLiveAgent(validateInput(e.target.value, "live_agent"))}
                                  required
                                  />
                                  {errors.live_agent && <small className="text-danger">{errors.live_agent}</small>}
                                  </Form.Group>
                                </td>
                                <td style={{ minHeight: "60px" , minWidth:"160px" }}>                        
                                  <Form.Group className="form-group">
                                    <Form.Control
                                    type="number"
                                    id="channel"
                                    placeholder="Channel"
                                    maxLength={100}
                                    min={0}
                                    max={availableLicence.channel}
                                    value={channel}
                                    onChange={(e) => setChannel(validateInput(e.target.value, "channel"))}
                                    required
                                    />
                                    {errors.channel && <small className="text-danger">{errors.channel}</small>}
                                  </Form.Group>
                                </td>
                               </tr>
                            </tbody>
                         </Table>
                    </div>

                     } */}

                    <div className="form-actions user-create-form__actions">
                      <Button
                        onClick={async () => {
                          submitForm();
                        }}
                        type="button"
                        variant="btn btn-primary"
                        disabled={buttonDisable}
                      >
                        {buttonDisable ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            />
                            &nbsp; Updating...
                          </>
                        ) : (
                          "Update User"
                        )}
                      </Button>
                    </div>
                  </form>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
    </>
  );
};

export default UserAdd;
